/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import { ref, computed } from 'vue';
import { EDIT_MODE } from '@/utils/enum';
import requestApi from '@/api';
import { useTemplateStore } from '@/store/modules/template'
import { createUUID } from "@/core/operation";
import { myGlobal } from '@/utils/public'

export const useEditModuleStore = defineStore('editModuleData', () => {

    const templateStore = useTemplateStore()
    const editMode = ref(0);
    const reqSubtitleText = ref(false);
    let requestTask = null;
    let reqController = null;
    let getController = null;
    const loadingSubtitle = ref(false)
    const reUndoLoading = ref(false)
    const location = ref(false)
    const canvasSubtitle = ref(false)
    const textIsEditing = ref(false)
    const svgColor = ref('');
    const canEditSubtitle = computed(() => templateStore.subtitle_data && templateStore.subtitle_data.length > 0)
    const dontRecord = computed(() => editMode.value == EDIT_MODE.IMAGE
        || textIsEditing.value || reUndoLoading.value
    )
    const notifySubtitle = ref({});

    function close() {
        editMode.value = EDIT_MODE.CLOSE;
        svgColor.value = '';
    }

    function setTextIsEditing(edit) {
        textIsEditing.value = edit;
    }

    function setReUndoLoading(enable) {
        reUndoLoading.value = enable;
    }

    function setEditMode(mode) {
        editMode.value = mode
        if(mode == EDIT_MODE.CLOSE){
            svgColor.value = '';
        }
    }

    function setSVGColor(value) {
        svgColor.value = value;
    }

    function setLocation(value) {
        if (editMode.value != EDIT_MODE.SUBTITLE) {
            location.value = value
        }
    }

    function selectCanvasSubtitle(value) {
        canvasSubtitle.value = value
    }

    function resetRequest() {
        templateStore.subtitle_data.value = null;
        if (editMode.value == EDIT_MODE.SUBTITLE) {
            editMode.value = EDIT_MODE.CLOSE;
        }
    }

    function closeSubtitle() {
        if (editMode.value == EDIT_MODE.SUBTITLE) {
            editMode.value = EDIT_MODE.CLOSE;
        }
    }

    function cancelRequest() {
        if (requestTask) {
            clearTimeout(requestTask);
            requestTask = null;
        }
        if (reqController) {
            reqController.abort();
            reqController = null; 
        }
        if (getController) {
            getController.abort();
            getController = null; 
        }
        loadingSubtitle.value = false;
    }

    function request(callback, mustRefresh) {
        if (loadingSubtitle.value) {
            if (myGlobal.curThrottle) {
                myGlobal.curThrottle.cancel();
                myGlobal.curThrottle = null;
            }
            callback('loading', '字幕正在生成中');
            return;
        }
        // if (templateStore.subtitle_record_id) {
        //     const errorCallback = ()=> {
        //         requestTask = setTimeout(() => {
        //             requestTask = null;
        //             getSubtitleResult(callback, errorCallback);
        //         }, 5000);
        //     };
        //     errorCallback();
        //     return;
        // }
        reqController = new AbortController();
        loadingSubtitle.value = true;
        let req = {};
        req.double_subtitle = templateStore.req_temp_double_subtitle;
        req.language_type = templateStore.subtitle_language_type;
        // req.emotion_id = params.emotionId?params.emotionId:0;
        req.speed = templateStore.speed;
        req.volume_value = templateStore.volume_value;
        req.pitch_offset_value = templateStore.pitch_offset_value;
        reqSubtitleText.value = false;
        if (templateStore.selected_tab === 1) {
            if ((templateStore.text_audio_url && templateStore.text_audio_url.length > 0) && !mustRefresh) {
                req.audio_url = templateStore.text_audio_url;
                req.sound_id = templateStore.sound_id;
            } else {
                req.text = templateStore.text;
                req.sound_id = templateStore.sound_id;
                if (!req.text || req.text == '') {
                    loadingSubtitle.value = false;
                    callback(false, '还未添加数字人旁白内容');
                    return;
                }
                reqSubtitleText.value = true;
            }
        } else {
            if (templateStore.audio_url && templateStore.audio_url.length > 0) {
                req.audio_url = templateStore.audio_url;
            } else {
                loadingSubtitle.value = false;
                callback(false, '还未添加数字人录音');
                return;
            }
        }
        requestApi.mainModule.generateSubtitle(req, reqController).then(res => {
            if (res && res.data.code == 200) {
                templateStore.setSubtitleRecordId(res.data.data.record_id);
                const errorCallback = (timeOut)=> {
                    requestTask = setTimeout(() => {
                        requestTask = null;
                        getSubtitleResult(callback, errorCallback);
                    }, timeOut?timeOut:5000);
                };
                errorCallback(3000);
            } else {
                loadingSubtitle.value = false;
                callback(false, res.data.message);
            }
          }).catch(err => {
            console.log('err.code',err.code,'err.message',err.message);
            loadingSubtitle.value = false;
            if (err && err.code == "ERR_CANCELED") {
                callback(false, '字幕请求已被取消');
            } else {
                callback(false, err);
            }
        })
    }

    function getSubtitleResult(callback, errorCallback) {
        let req = {record_id:templateStore.subtitle_record_id};
        getController = new AbortController();
        requestApi.mainModule.getSubtitleResult(req, getController).then(res => {
            if (res && res.data.code == 200) {
                if (res.data.data.status < 2) {
                    errorCallback && errorCallback();
                } else {
                    setSuccess(res.data, callback);
                    loadingSubtitle.value = false;
                }
            } else {
                callback(false, res.data.message);
                loadingSubtitle.value = false;
            }
          }).catch(err => {
            if (err && err.code == "ERR_CANCELED") {
                callback(false, '字幕请求已被取消');
            } else {
                callback(false, err);
            }
            loadingSubtitle.value = false;
        })
    }

    function setSuccess(res, callback){
        if (res != null && res.data && res.code === 200) {
            const status = res.data.status;
            if (status == 4) {//成功
                res.data.segments.forEach((e, i) => {
                    e.playing = i == 0;
                    e.mainUuid = createUUID();
                    e.subUuid = createUUID();
                });

                const lastParams = {};
                lastParams.subtitle_audio_url = templateStore.subtitle_audio_url;
                lastParams.subtitle_audio_duration = templateStore.subtitle_audio_duration;
                lastParams.double_subtitle = templateStore.double_subtitle;
                lastParams.subtitle_data = templateStore.subtitle_data;

                const nowParams = {};
                nowParams.subtitle_audio_url = res.data.oss_url;
                nowParams.subtitle_audio_duration = res.data.audio_duration;
                nowParams.double_subtitle = res.data.double_subtitle;
                nowParams.subtitle_data = res.data.segments;

                templateStore.setSubtitleRecordId(null);
                templateStore.setSubtitleAudioUrl(res.data.oss_url);
                templateStore.setSubtitleAudioDuration(res.data.audio_duration);
                templateStore.setDoubleSubtitle(res.data.double_subtitle);
                templateStore.setSubtitleData(res.data.segments);
                //  设置试听
                if (reqSubtitleText.value) {
                    templateStore.setTextAudioInfo(res.data.audio_duration, res.data.oss_url)
                    templateStore.setRemainingDuration(res.data.remaining_duration, res.data.remaining_times)
                }

                callback && callback(true, '字幕已生成');

                notifySubtitle.value = {last:lastParams, now:nowParams};
            } else if (status == 0 || status == 1 || status == 2) { //生成中
                callback && callback(false, '字幕生成中');
            } else if (status == 5 || status == 6) { //异常失败
                callback && callback(false, '字幕生成失败');
            } else if (status == 9) { //语种不正确
                callback && callback(false, '字幕语种不正确');
            }
        } else {
            callback && callback(false, '网络请求失败');
        }
    }

    function saveSubtitleData(list) {
        // localStorage.removeItem('subtitleData')
        // localStorage.getItem('subtitleData')
        // const temp = {};
        // temp.segments = list;
        // temp.audioUrl = tempData.audioUrl;
        // temp.audioDuration = tempData.audioDuration;
        // temp.segments = tempData.segments;
        // localStorage.setItem('subtitleData', JSON.stringify(temp))
    }

    return { canEditSubtitle, request, resetRequest, editMode, loadingSubtitle, location,canvasSubtitle, selectCanvasSubtitle, textIsEditing, setTextIsEditing,
        close, setEditMode, saveSubtitleData, cancelRequest, closeSubtitle, setLocation, dontRecord, notifySubtitle, reUndoLoading, setReUndoLoading,setSVGColor,svgColor }

})
